import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import Login from "./components/login";
import OperatorHome from "./components/operatorHome";
import ServiceOrders from "./components/serviceOrders";
import ClientsScreen from "./components/clientsScreen";
import EditClient from "./components/editClient";
import AdminMenu from "./AdminPages/menu";
import Dashboard from "./AdminPages/dashboard";
import OrdersScreen from "./components/ordersScreen";
import AdminClientsScreen from "./AdminPages/clients/clientsListScreen";
import ClientSpecificOrdersTable from "./AdminPages/clients/clientSpecificOrders";
import OrderDetailsForm from "./AdminPages/orderDetailsForm";
import OrderDetailsView from "./AdminPages/orderDetailsView";
import Bills from "./AdminPages/bills";
import RegisterBillPayment from "./AdminPages/registerBillPayment";
import CashExtraction from "./AdminPages/cashExtaction";
import CashAdd from "./AdminPages/cashAdd";
import CashMovements from "./AdminPages/cashMovements";
import ClientBillDetails from "./AdminPages/clientBillDetails";
import ClientSelection from "./AdminPages/clientCurrentAccount/clientSelection";
import ClientCurrentAccount from "./AdminPages/clientCurrentAccount";
import CheckReports from "./AdminPages/reports/checkReports";
import ServiceStatus from "./AdminPages/reports/serviceStatus";
import DebtAging from "./AdminPages/reports/debtAging";
import OperatorProduction from "./AdminPages/reports/operatorProduction";
import BillingReport from "./AdminPages/reports/billing";
import IvaBook from "./AdminPages/reports/ivaBook";
import TicketDetailsForm from "./AdminPages/ticketDetailsForm";
import VersionDisplay from "./components/VersionDisplay";

const adminRoutes = [
  { path: "/admin", element: <Dashboard /> },
  { path: "/admin-orders", element: <AdminMenu /> },
  { path: "/orders-per-client", element: <AdminClientsScreen /> },
  { path: "/bills-per-client", element: <Bills /> },
  { path: "/client-specific-orders", element: <ClientSpecificOrdersTable /> },
  { path: "/order-details-form", element: <OrderDetailsForm /> },
  { path: "/order-details-view", element: <OrderDetailsView /> },
  { path: "/register-bill-payment", element: <RegisterBillPayment /> },
  { path: "/cash-movements", element: <CashMovements /> },
  { path: "/cash-extraction", element: <CashExtraction /> },
  { path: "/cash-add", element: <CashAdd /> },
  { path: "/client-bill-details", element: <ClientBillDetails /> },
  { path: "/clients-for-current-account", element: <ClientSelection /> },
  { path: "/client-current-account", element: <ClientCurrentAccount /> },
  { path: "/check-reports", element: <CheckReports /> },
  { path: "/reporte-deuda", element: <DebtAging /> },
  { path: "/reporte-operadores", element: <OperatorProduction /> },
  { path: "/reporte-facturacion", element: <BillingReport /> },
  { path: "/reporte-libro-iva", element: <IvaBook /> },
  { path: "/estado-servicios-arca", element: <ServiceStatus /> },
  { path: "/ticket-details-form", element: <TicketDetailsForm /> },
];

const protectedRoutes = [
  { path: "/", element: <OperatorHome /> },
  { path: "/order-table", element: <OrdersScreen /> },
  { path: "/new-order", element: <ServiceOrders /> },
  { path: "/clients", element: <ClientsScreen /> },
  { path: "/edit-client", element: <EditClient /> },
  { path: "/edit-order", element: <ServiceOrders /> },
];

const App = () => {
  return (
    <Router>
      <Routes>
        <Route exact path="/login" element={<Login />} />
        {adminRoutes.map(({ path, element }) => (
          <Route
            key={path}
            path={path}
            element={
              <ProtectedRoute isAdminRoute={true}>{element}</ProtectedRoute>
            }
          />
        ))}
        {protectedRoutes.map(({ path, element }) => (
          <Route
            key={path}
            path={path}
            element={<ProtectedRoute>{element}</ProtectedRoute>}
          />
        ))}
      </Routes>
      <VersionDisplay position="bottom-right" />
    </Router>
  );
};

export default App;
